// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookFreeHotelAmendsLayout-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/BookFreeHotelAmendsLayout/BookFreeHotelAmendsLayout.desktop.scss
 ** module id = 946
 ** module chunks = 1
 **/